import React, { useCallback, useEffect, useState } from "react";
import api from "../services/api";
import Header from "../components/Header";
import { Button, Field, Input, Select, Textarea, Tag, Modal, tomDoStatus, dataBR, paraInputData } from "../components/ui";

const FORM_VAZIO = {
    num_processo: "",
    nome_prazo: "",
    data_prazo: "",
    descricao_prazo: "",
    status_prazo: "pendente",
    fatal: false
};
const STATUS_PRAZO = ["pendente", "concluido", "adiado", "cancelado"];


const PrazosProcesso = () => {
    const [busca, setBusca] = useState(() => new URLSearchParams(window.location.search).get("q") || "");
    const [prazos, setPrazos] = useState([]);
    const [processos, setProcessos] = useState([]);
    const [processoSelecionado, setProcessoSelecionado] = useState(null);
    const [prazoSelecionado, setPrazoSelecionado] = useState(null);
    const [mostrarProcessos, setMostrarProcessos] = useState(false);
    const [mostrarAdd, setMostrarAdd] = useState(false);
    const [mostrarEdit, setMostrarEdit] = useState(false);
    const [mostrarInfo, setMostrarInfo] = useState(false);
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState(null);
    const [formData, setFormData] = useState(FORM_VAZIO);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const listarPrazos = useCallback(async () => {
        try {
            const response = await api.get("/prazos");
            setPrazos(response.data);
        } catch (error) {
            console.error("Erro ao buscar prazos:", error);
        }
    }, []);

    useEffect(() => {
        listarPrazos();
        api.get("/processos").then((r) => setProcessos(r.data)).catch(() => {});
    }, [listarPrazos]);

    const criarPrazo = async (e) => {
        e.preventDefault();
        setCarregando(true);
        setErro(null);
        try {
            await api.post("/prazos", formData);
            setFormData(FORM_VAZIO);
            setMostrarAdd(false);
            listarPrazos();
        } catch (err) {
            setErro(err.response?.data?.error || err.message);
        } finally {
            setCarregando(false);
        }
    };

    const editarPrazo = async (e) => {
        e.preventDefault();
        setCarregando(true);
        setErro(null);
        try {
            await api.put(`/prazos/${prazoSelecionado.cod_prazo}`, formData);
            setMostrarEdit(false);
            listarPrazos();
        } catch (err) {
            setErro(err.response?.data?.error || "Não foi possível salvar o prazo.");
        } finally {
            setCarregando(false);
        }
    };

    const deletarPrazo = async (cod_prazo) => {
        if (!window.confirm("Excluir este prazo?")) return;
        try {
            await api.delete(`/prazos/${cod_prazo}`);
            setMostrarInfo(false);
            listarPrazos();
        } catch (error) {
            alert(error.response?.data?.error || "Não foi possível excluir o prazo.");
        }
    };

    useEffect(() => {
        if (mostrarEdit && prazoSelecionado) {
            setFormData({
                num_processo: prazoSelecionado.num_processo || "",
                nome_prazo: prazoSelecionado.nome_prazo || "",
                data_prazo: paraInputData(prazoSelecionado.data_prazo),
                descricao_prazo: prazoSelecionado.descricao_prazo || "",
                status_prazo: prazoSelecionado.status_prazo || "pendente",
                fatal: !!prazoSelecionado.fatal
            });
        }
    }, [prazoSelecionado, mostrarEdit]);

    const prazosFiltrados = prazos.filter((p) => {
        const q = busca.toLowerCase();
        return (
            (p.nome_prazo || "").toLowerCase().includes(q) ||
            (p.status_prazo || "").toLowerCase().includes(q) ||
            String(p.num_processo || "").includes(busca)
        );
    });

    const formPrazo = (onSubmit, aoVoltar, processoTravado) => (
        <form onSubmit={onSubmit} style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            <div className="grid-form">
                <Field label="Nº do processo"><Input name="num_processo" value={formData.num_processo} readOnly={processoTravado} onChange={handleChange} /></Field>
                <Field label="Nome do prazo"><Input name="nome_prazo" required value={formData.nome_prazo} onChange={handleChange} /></Field>
                <Field label="Data"><Input type="date" name="data_prazo" required value={formData.data_prazo} onChange={handleChange} /></Field>
                <Field label="Status">
                    <Select name="status_prazo" required value={formData.status_prazo} onChange={handleChange}>
                        {STATUS_PRAZO.map((s) => <option key={s} value={s}>{s}</option>)}
                    </Select>
                </Field>
                <div className="field span-2">
                    <label style={{ display: "flex", alignItems: "center", gap: 8, cursor: "pointer", fontSize: 14 }}>
                        <input
                            type="checkbox"
                            checked={formData.fatal}
                            onChange={(e) => setFormData((p) => ({ ...p, fatal: e.target.checked }))}
                            style={{ width: 15, height: 15, accentColor: "var(--color-accent-600)" }}
                        />
                        Prazo fatal (peremptório — não se prorroga)
                    </label>
                </div>
                <Field label="Descrição" className="span-2"><Textarea name="descricao_prazo" value={formData.descricao_prazo} onChange={handleChange} /></Field>
            </div>
            <div className="modal-acoes">
                {erro && <p className="erro">{erro}</p>}
                <Button variante="secondary" onClick={aoVoltar}>Voltar</Button>
                <Button type="submit" disabled={carregando}>{carregando ? "Salvando..." : "Salvar"}</Button>
            </div>
        </form>
    );

    return (
        <div>
            <Header />

            <main className="page">
                <div className="toolbar">
                    <h2 style={{ margin: 0 }}>Prazos de processos</h2>
                    <div className="toolbar-spacer">
                        <Input placeholder="Buscar" value={busca} onChange={(e) => setBusca(e.target.value)} />
                        <Button onClick={() => setMostrarProcessos(true)}>Novo prazo</Button>
                    </div>
                </div>

                <p className="text-muted" style={{ margin: "0 0 4px", fontSize: 13 }}>
                    A contagem "em X dias" segue os <strong>dias úteis</strong> do prazo
                    processual (CPC art. 219): pula fins de semana, feriados nacionais e o
                    recesso forense (20/12–20/01). A data exibida é o vencimento real.
                </p>

                <div className="lista-urgencia">
                    <div className="lu-cabecalho">
                        <span>Prazo / cliente</span>
                        <span title="Contagem em dias úteis (CPC art. 219)">Situação (dias úteis)</span>
                        <span>Data</span>
                    </div>
                    {prazosFiltrados.map((p) => {
                        // dias_uteis vem pronto do back (CPC art. 219, já com feriados)
                        const dias = p.dias_uteis ?? 0;
                        const pendente = p.status_prazo === "pendente";
                        // Faixa: vermelho (fatal/vencido/hoje), laranja (≤3 dias úteis), verde (concluído), neutro (resto)
                        let faixa = "neutro";
                        if (!pendente) faixa = p.status_prazo === "concluido" ? "ok" : "neutro";
                        else if (dias <= 0 || p.fatal) faixa = "critico";
                        else if (dias <= 3) faixa = "aviso";

                        return (
                            <button key={p.cod_prazo} className={`lu-linha lu-${faixa}`} onClick={() => { setPrazoSelecionado(p); setMostrarInfo(true); }}>
                                <span className="lu-corpo">
                                    <span className="lu-titulo">
                                        {p.nome_prazo}
                                        {!!p.fatal && <Tag tom="danger">fatal</Tag>}
                                    </span>
                                    <span className="lu-sub">{p.nome_cliente} · {p.num_processo}</span>
                                </span>
                                <span className="lu-situacao" title="Dias úteis (exclui fins de semana, feriados e recesso forense)">
                                    {pendente && dias < 0 && <Tag tom="danger">vencido há {Math.abs(dias)} {Math.abs(dias) === 1 ? "dia útil" : "dias úteis"}</Tag>}
                                    {pendente && dias === 0 && <Tag tom="danger">vence hoje</Tag>}
                                    {pendente && dias > 0 && dias <= 3 && <Tag tom="warn">em {dias} {dias === 1 ? "dia útil" : "dias úteis"}</Tag>}
                                    {pendente && dias > 3 && <span className="text-muted">em {dias} dias úteis</span>}
                                    {!pendente && <Tag tom={tomDoStatus(p.status_prazo)}>{p.status_prazo}</Tag>}
                                </span>
                                <span className="lu-data">{dataBR(p.data_prazo)}</span>
                            </button>
                        );
                    })}
                    {prazosFiltrados.length === 0 && (
                        <p className="text-muted" style={{ padding: "16px" }}>Nenhum prazo encontrado.</p>
                    )}
                </div>

                {mostrarInfo && prazoSelecionado && (
                    <Modal titulo={prazoSelecionado.nome_prazo} onFechar={() => setMostrarInfo(false)}>
                        <div className="grid-form">
                            <Field label="Nº do processo"><Input value={prazoSelecionado.num_processo} readOnly /></Field>
                            <Field label="Data"><Input value={dataBR(prazoSelecionado.data_prazo)} readOnly /></Field>
                            <Field label="Status"><Input value={prazoSelecionado.status_prazo} readOnly /></Field>
                            <Field label="Tipo"><Input value={prazoSelecionado.fatal ? "Prazo fatal (peremptório)" : "Prazo ordinário"} readOnly /></Field>
                            <Field label="Descrição" className="span-2"><Textarea value={prazoSelecionado.descricao_prazo || ""} readOnly /></Field>
                        </div>
                        <div className="modal-acoes">
                            <Button variante="danger" onClick={() => deletarPrazo(prazoSelecionado.cod_prazo)}>Excluir</Button>
                            <Button variante="secondary" onClick={() => setMostrarInfo(false)}>Voltar</Button>
                            <Button onClick={() => { setErro(null); setMostrarEdit(true); setMostrarInfo(false); }}>Editar</Button>
                        </div>
                    </Modal>
                )}

                {mostrarEdit && prazoSelecionado && (
                    <Modal titulo="Editar prazo" onFechar={() => setMostrarEdit(false)}>
                        {formPrazo(editarPrazo, () => setMostrarEdit(false), true)}
                    </Modal>
                )}

                {mostrarProcessos && (
                    <Modal titulo="Escolha o processo" largo onFechar={() => setMostrarProcessos(false)}>
                        <div className="scroll-x">
                            <table className="table">
                                <thead><tr><th>Contrato</th><th>Cliente</th><th>Nº Processo</th><th>Status</th></tr></thead>
                                <tbody>
                                    {processos.map((p) => (
                                        <tr key={p.num_processo} className="clicavel" onClick={() => {
                                            setProcessoSelecionado(p);
                                            setFormData({ ...FORM_VAZIO, num_processo: p.num_processo });
                                            setErro(null);
                                            setMostrarProcessos(false);
                                            setMostrarAdd(true);
                                        }}>
                                            <td className="num">{p.cod_contrato}</td>
                                            <td>{p.nome_cliente}</td>
                                            <td className="num">{p.num_processo}</td>
                                            <td><Tag tom={tomDoStatus(p.status_processo)}>{p.status_processo}</Tag></td>
                                        </tr>
                                    ))}
                                    {processos.length === 0 && <tr><td colSpan="4" className="text-muted">Cadastre um processo primeiro.</td></tr>}
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-acoes">
                            <Button variante="secondary" onClick={() => setMostrarProcessos(false)}>Voltar</Button>
                        </div>
                    </Modal>
                )}

                {mostrarAdd && processoSelecionado && (
                    <Modal titulo="Novo prazo" onFechar={() => setMostrarAdd(false)}>
                        {formPrazo(criarPrazo, () => { setMostrarAdd(false); setMostrarProcessos(true); }, true)}
                    </Modal>
                )}
            </main>
        </div>
    );
};

export default PrazosProcesso;
